// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"7150":"d01bf63a","7523":"03cbbe93"}[chunkId] + ".css";
};